import React from "react";
import { Helmet } from "react-helmet";

export const Feedback = () => {
  return (
    <div className={"p-2 p-lg-5"}>      
      <Helmet>
        <title>Minha Glambox : Feedback</title>
      </Helmet>
    
      <h1 className={"display-1"}>Feedback</h1>
      <div className={ "p-xl-5 p-3 level-2 feedback-page" }>
        <h2>Herbarium Óleo de Rosa Mosqueta</h2>
        <div className={ "linha-status" }>
          <div className={ "body-progress" }>
            <div className={ "progress"}>
              <div className={ "bar" } style={{ width: "8.333333333333332%" }}></div>
            </div>
            <div className={ "question-number" }>Questão 1 de 12</div>
          </div>
        </div>
        <h3>Qual frase melhor descreve o seu comportamento em relação a sua escolha e compra de produtos para o cuidado da pele?</h3>
        <div className={ "questions-body" }>
          <ul>
            <li className={ "true" }>
              <span className={ "control-group" }>
                <span className={ "controlls" }>
                  <input type="radio" className={ "option" } name={ "teste " } id={ "opt1" }/>
                  <label htmlFor={ "opt1" }>
                    <span>Sempre que possível dou preferência a produtos naturais para o cuidado da minha pele corporal.</span>
                  </label>
                </span>
              </span>
            </li>
            <li>
              <span className={ "control-group" }>
                <span className={ "controlls" }>
                  <input type="radio" className={ "option" } name={ "teste " } id={ "opt2"} />
                  <label htmlFor={ "opt2"}>
                    <span>
                      Gostaria de priorizar o uso de produtos naturais para o cuidado da minha pele corporal, mas ainda desconheço ou não encontro opções para tudo que preciso.
                    </span>
                  </label>
                </span>
              </span>
            </li>
            <li>
              <span className={ "control-group" }>
                <span className={ "controlls" }>
                  <input type="radio" className={ "option" } name={ "teste " } id={ "opt3" } />
                  <label htmlFor={ "opt3" }>
                    <span>Não dou preferência por produtos naturais para o cuidado da minha pele corporal.</span>
                  </label>
                </span>
              </span>
            </li>
            <li><hr/></li>
            <li>
              <span className={ "control-group" }>
                <span className={ "controlls level-2" } style={{ width: "100%" }}>
                  <input type="text" className={ "option" } name={ "teste " } id={ "opt3" } style={{ width: "100%" }} />
                  {/*<label htmlFor={ "opt3" }>
                    <span>Não dou preferência por produtos naturais para o cuidado da minha pele corporal.</span>
                  </label>*/}
                </span>
              </span>
            </li>
            <li><hr/></li>
            <li>
              <span className={ "control-group" }>
                <span className={ "controlls level-2" } style={{ width: "100%" }}>
                  <textarea style={{ width: "100%" }}></textarea>
                  {/*<label htmlFor={ "opt3" }>
                    <span>Não dou preferência por produtos naturais para o cuidado da minha pele corporal.</span>
                  </label>*/}
                </span>
              </span>
            </li>
            <li><hr/></li>
            <li>
              <span className={ "control-group" }>
                <span className={ "controlls" }>
                  <input type="checkbox" name={ "testecheckbox " } id={ "opt1checkbox"} />
                  <label htmlFor={ "opt1checkbox"}>
                    <span>
                      Gostaria de priorizar o uso de produtos naturais para o cuidado da minha pele corporal, mas ainda desconheço ou não encontro opções para tudo que preciso.
                    </span>
                  </label>
                </span>
              </span>
            </li>
            <li>
              <span className={ "control-group" }>
                <span className={ "controlls" }>
                  <input type="checkbox" name={ "testecheckbox " } id={ "opt2checkbox"} />
                  <label htmlFor={ "opt2checkbox" }>
                    <span>
                      Gostaria de priorizar o uso de produtos naturais para o cuidado da minha pele corporal, mas ainda desconheço ou não encontro opções para tudo que preciso.
                    </span>
                  </label>
                </span>
              </span>
            </li>
            <li>
              <span className={ "control-group" }>
                <span className={ "controlls" }>
                  <input type="checkbox" name={ "testecheckbox " } id={ "opt3checkbox"} />
                  <label htmlFor={ "opt3checkbox" }>
                    <span>
                      Gostaria de priorizar o uso de produtos naturais para o cuidado da minha pele corporal, mas ainda desconheço ou não encontro opções para tudo que preciso.
                    </span>
                  </label>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className={ "action" }>
          <button className={ "btn btn-small btn-light-pink" }>Voltar</button>
          <button className={ "btn btn-small btn-light-lime" }>Avançar</button>
        </div>        
      </div>
    </div>
  );
};
